export const CEST_HTML_URL =
  'https://www.confaz.fazenda.gov.br/legislacao/convenios/2018/CV142_18';

export const CEST_GOLDEN_CERVEJA_GARRAFA_RETORNAVEL = '0302100';
export const CEST_GOLDEN_NCM_CERVEJA = '22030000';
export const CEST_MIN_CODES = 950;
export const CEST_MAX_CODES = 1050;
